import {createContext} from 'react';

export const CrossPropertyRoomTypesListContext = createContext({});
